define('widgets/olark/olarkLoginModel',[], function () {

    function OlarkLoginModel(validity, values) {
        var self = this;

        self.email = values.email();
        self.name = {
            firstName: values.name(),
            lastName: values.name()
        };
    }

    return OlarkLoginModel;

});

